/**
 * Script pour la page de gestion des bannières artisans (côté agent immo)
 */
var agencesPublicitesArtisans = {

    formatColActif: function(actif) {
        if (actif) {
            return 'Oui';
        } else {
            return 'Non';
        }
    },

    operateFormatter: function(value, row, index) {
        var btnUploadDocs = CAN_USER_UPLOAD_DOC
            ? '<button class="btn btn-icon btn-voir-folder-documents"' +
                     ' data-dossier-uuid="' + row.foUuid + '" title="Charger les documents">' +
                '<span class="icon icon-checklist"></span>' +
              '</button>'
            : '';

        return [
            '<a class="btn edit_candidat" href="/agent_immo/publicites_artisans/edit/' + value + '"\
                title="Éditer la bannière">\
                    <img src="assets/img/edit.svg" alt="editer" width="15">\
            </a>',
            btnUploadDocs,
            '<a href="agent_immo/publicites_artisans/supprimer/' + value + '"\
                class="btn delete_contact" data-id="' + value + '" title="Supprimer cette publicité"' +
              ' data-id="' + value + '">\
                    <img src="assets/img/cancel_red.svg" width="15" alt="supprimer">\
             </a>',
        ].join('');
    },

    initEvents: function() {
        var $modal = $('#modal-voir-folder-document');

        $('.table_clust').on('click', '.btn-voir-folder-documents', function(e) {
            var $btn      = $(e.currentTarget);
            var uuid = $btn.data('dossier-uuid');
            $modal.find('.modal-header h2 span i').text($btn.parents('tr').data('agence'));
            $('#modal-voir-folder-document').modal();
            artisansFolders.getArtisanFolderPieces(uuid);

            $modal.on('hide.bs.modal', function() {
                window.location = window.location;
            });
        });
    },

    formatLogo: function(value, row, index) {
        if (value) {
            return '<img src="' + value + '" height="50px">';
        } else {
            return '';
        }
    },
};
